<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">
            {{ $t("ReportUser") }}
          </v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="reportdata-card-main" style="margin-top: 1rem">
        <v-card-title class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3" size="28">
              mdi-account-group
            </v-icon>
            <h3 class="text-h5 font-weight-bold text-primary">
              User Report Management
            </h3>
          </div>
        </v-card-title>

        <v-card-text style="padding: 0">
          <!-- Main Filter Row -->
          <v-row class="mb-4">
            <!-- Date Range Section -->
            <v-col cols="12" md="10">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2 ml-2" color="primary" size="20">
                    mdi-calendar-range
                  </v-icon>
                  Date Range
                </h4>
                <v-row class="mx-4">
                  <v-col cols="5">
                    <v-card variant="outlined" class="reportdata-card-outlined">
                      <v-card-text class="pa-3">
                        <v-menu
                          v-model="startDateFlag"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          location="bottom"
                          min-width="auto">
                          <template #activator="{ props }">
                            <v-text-field
                              id="startdate-field-reportusertop10"
                              v-model="startDate"
                              label="Start Date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              v-bind="props"
                              density="compact"
                              color="primary"
                              class="reportdata-field-date"
                              clearable>
                              <template #append-inner>
                                <v-tooltip location="top" max-width="200">
                                  <template #activator="{ props }">
                                    <v-icon
                                      size="small"
                                      color="grey-darken-1"
                                      v-bind="props">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Select start date for report</span>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            id="startdate-datapicker-reportusertop10"
                            v-model="startDate"
                            :max="endDate != null ? endDate : null"
                            @update:model-value="
                              (val) => {
                                startDate = formatDate(val);
                                startDateFlag = false;
                              }
                            "
                            color="primary"></v-date-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="2" class="d-flex align-center justify-center">
                    <v-icon color="grey-darken-2" size="24">
                      mdi-arrow-right
                    </v-icon>
                  </v-col>

                  <v-col cols="5">
                    <v-card variant="outlined" class="reportdata-card-outlined">
                      <v-card-text class="pa-3">
                        <v-menu
                          v-model="endDateFlag"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          location="bottom"
                          min-width="auto">
                          <template #activator="{ props }">
                            <v-text-field
                              id="enddate-field-reportusertop10"
                              v-model="endDate"
                              label="End Date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              variant="outlined"
                              v-bind="props"
                              density="compact"
                              color="primary"
                              class="reportdata-field-date"
                              clearable>
                              <template #append-inner>
                                <v-tooltip location="top" max-width="200">
                                  <template #activator="{ props }">
                                    <v-icon
                                      size="small"
                                      color="grey-darken-1"
                                      v-bind="props">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Select end date for report</span>
                                </v-tooltip>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            id="enddate-datapicker-reportusertop10"
                            v-model="endDate"
                            :min="startDate != null ? startDate : null"
                            @update:model-value="
                              (val) => {
                                endDate = formatDate(val);
                                endDateFlag = false;
                              }
                            "
                            color="primary"></v-date-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <!-- Action Button Section -->
            <v-col
              cols="12"
              md="2"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              ">
              <v-btn
                id="button-search-reportusertop10"
                color="primary"
                variant="elevated"
                size="large"
                @click="Search()"
                class="reportdata-btn-search w-100"
                prepend-icon="mdi-magnify"
                style="margin-top: 20px; margin-right: 30px">
                SEARCH
              </v-btn>
            </v-col>
          </v-row>

          <!-- Top 3 Ranking Cards -->
          <v-row class="mb-4">
            <v-col cols="12">
              <div class="reportdata-filter-section">
                <h4 class="reportdata-section-title mb-3">
                  <v-icon class="mr-2 ml-3" color="primary" size="20">
                    mdi-podium
                  </v-icon>
                  Top 3 Users
                </h4>
                <v-row class="mx-4">
                  <v-col
                    v-for="item in dataTable.slice(0, 3)"
                    :key="item.no"
                    cols="12"
                    sm="4"
                    md="4">
                    <v-card
                      class="reportdata-user-rank-card"
                      :class="`rank-${item.no}`"
                      elevation="4"
                      min-height="200">
                      <v-card-title
                        class="reportdata-user-rank-header d-flex align-center justify-center"
                        :class="
                          item.no == 1
                            ? 'rank-1-header'
                            : item.no == 2
                            ? 'rank-2-header'
                            : 'rank-3-header'
                        ">
                        <v-icon size="60" color="white">
                          mdi-numeric-{{ item.no }}-circle
                        </v-icon>
                      </v-card-title>
                      <v-card-text class="pa-4">
                        <div class="reportdata-user-rank-content">
                          <div class="user-info mb-3">
                            <div class="reportdata-user-list">
                              <span
                                v-for="(subItem, index) in item.title"
                                :key="subItem"
                                class="user-text">
                                {{
                                  subArray(subItem, index, item.title.length)
                                }}
                              </span>
                            </div>
                          </div>
                          <div class="count-section text-center">
                            <v-chip
                              size="large"
                              :color="
                                item.no == 1
                                  ? 'amber'
                                  : item.no == 2
                                  ? 'grey'
                                  : 'orange'
                              "
                              variant="elevated"
                              class="px-4">
                              <v-icon class="mr-2">mdi-account-multiple</v-icon>
                              {{ item.count }} Questions
                            </v-chip>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <!-- Complete Ranking Table -->
          <v-card class="reportdata-card-table">
            <div class="reportdata-table-container">
              <v-data-table-server
                :items="dataTable"
                :headers="headers"
                hide-default-footer
                class="reportdata-table-modern"
                density="comfortable"
                hover>
                <template #top>
                  <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
                    <v-toolbar-title class="text-h6 font-weight-medium">
                      <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                      User Report Data ({{ dataTable.length }} records)
                    </v-toolbar-title>
                  </v-toolbar>
                </template>

                <template #item="{ item }">
                  <tr class="reportdata-table-row">
                    <td class="text-center">
                      <v-chip
                        size="small"
                        :color="
                          item.no <= 3
                            ? item.no == 1
                              ? 'amber'
                              : item.no == 2
                              ? 'grey'
                              : 'orange'
                            : 'primary'
                        "
                        variant="outlined">
                        {{ item.no }}
                      </v-chip>
                    </td>
                    <td>
                      <div class="reportdata-text-container">
                        <span
                          v-for="(subItem, index) in item.title"
                          :key="subItem"
                          class="reportdata-text-standard">
                          {{ subArray(subItem, index, item.title.length) }}
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ substringLong(item.count) }}
                    </td>
                  </tr>
                </template>
              </v-data-table-server>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
    <v-overlay :value="loading">
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
export default {
  name: "ReportUserTop10",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    today: null,
    loading: true,
    options: {},

    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,

    dataTable: [],
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("Rank"),
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          title: "User ID",
          align: "left",
          sortable: false,
          width: "500px",
        },
        {
          title: "Total Questions",
          align: "center",
          sortable: false,
          width: "100px",
        },
      ];
    },
  },
  watch: {
    // options: {
    //   handler() {
    //     this.GetReport();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    Search() {
      let self = this;
      self.loading = true;
      self.GetReport();
    },

    GetReport() {
      let self = this;
      self.loading = true;

      if (self.startDate != null && self.endDate != null) {
        let temp = {
          StartDate: self.startDate,
          EndDate: self.endDate,
        };

        self.$call.ReportUser(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.dataTable = dataResponse.data;
            } else {
              self.dataTable = [];
            }
            self.loading = false;
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please fill the required fields!!!",
          showConfirmButton: false,
          timer: 1800,
        });
        self.loading = false;
        return;
      }
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },

    substringLong(value) {
      if (value == null) {
        return "-";
      }
      if (value.length > 81) {
        return value.substring(0, 80) + ".....";
      }
      return value;
    },

    subArray(value, index, sum) {
      if (index == sum - 1) {
        return value;
      } else {
        return value + ", ";
      }
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    var date = new Date();
    self.endDate = self.convertDateToString2(date);
    // date.setDate(date.getDate() - 1);
    self.startDate = self.convertDateToString2(date);
    self.GetReport();
  },
};
</script>
<style scoped>
.rank-1-header {
  background: linear-gradient(135deg, #ffd700, #ffa500) !important;
}

.rank-2-header {
  background: linear-gradient(135deg, #c0c0c0, #a8a8a8) !important;
}

.rank-3-header {
  background: linear-gradient(135deg, #cd7f32, #d2691e) !important;
}
</style>
